import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_87: FaireProductEntity = {
  token: "starter_collection_87",
  type: "product",
  name: "Paprika Chef Towels",
  brandName: "Hedley & Bennett",
  imageUrl:
    "https://cdn.faire.com/fastly/63906011f07357ec35b7b6d9d9a90a1a47a97c938252c2ed681183ee613752d9.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 28,
  msrpDollars: 56,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
